(function () {
    'use strict';
    
    const DEFAULT_CHAT_SELECTOR = '.sas-scripts-head-chat';
    // TO DO: remove sas-slideshow-component from selectors (check if it's still needed)
    const SLIDESHOW_SELECTORS = ['sas-slideshow-component', 'm-slideshow'];
    
    let config = null;
    let keywords = [];
    let customSelectors = [];
    let isInitialized = false;
    let scrollTimer = null;
  
    function parseKeywords(raw) {
      if (!raw || typeof raw !== 'string') return [];
      return raw
        .split(',')
        .map((k) => k.trim().toLowerCase())
        .filter(Boolean);
    }
  
    function parseSelectors(raw) {
      if (!raw || typeof raw !== 'string') return [];
      return raw
        .split(/[,\n]/)
        .map((s) => {
          s = s.trim();
          if (!s) return '';
          if (s.startsWith('#') || s.startsWith('.')) return s;
          return '#' + s; // No prefix = ID
        })
        .filter(Boolean);
    }
  
    function getTargets() {
      const selectors = [DEFAULT_CHAT_SELECTOR, ...customSelectors];
      const nodes = [];
      selectors.forEach((sel) => {
        try {
          document.querySelectorAll(sel).forEach((el) => {
            if (el) nodes.push(el);
          });
        } catch (e) {}
      });
      return nodes;
    }
  
    function hideWidget(el) {
      if (!el) return;
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('opacity', '0', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
    }
  
    function showWidget(el) {
      if (!el) return;
      el.style.removeProperty('display');
      el.style.removeProperty('visibility');
      el.style.removeProperty('opacity');
      el.style.removeProperty('pointer-events');
    }
  
    // Check if image contains keyword in URL
    function imageHasKeyword(img) {
      if (!img || !keywords.length) return false;
      
      const src = (img.src || img.dataset.src || img.getAttribute('src') || '').toLowerCase();
      return keywords.some((kw) => src.includes(kw));
    }
  
    // Find active slide from sas-slideshow-component
    function getActiveSlideSas(slideshow) {
      const slides = slideshow.querySelectorAll('.sas-slideshow__banner');
      if (!slides.length) return null;
      
      let active = null;
      let maxArea = 0;
      for (const slide of slides) {
        const rect = slide.getBoundingClientRect();
        const area = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
        if (area > maxArea && rect.top < window.innerHeight && rect.bottom > 0) {
          maxArea = area;
          active = slide;
        }
      }
      return active;
    }
  
    // Find active slide from m-slideshow
    function getActiveSlideM(slideshow) {
      // Swiper active
      const active = slideshow.querySelector('.swiper-slide-active');
      if (active) return active;
      
      // Swiper instance
      const container = slideshow.querySelector('.swiper-container');
      if (container?.swiper?.slides) {
        const idx = container.swiper.activeIndex;
        if (container.swiper.slides[idx]) return container.swiper.slides[idx];
      }
      
      return null;
    }
  
    // Check if widgets should be hidden
    function shouldHide() {
      if (!keywords.length) return false;
  
      // Find visible slideshows
      const slideshows = [];
      SLIDESHOW_SELECTORS.forEach((sel) => {
        document.querySelectorAll(sel).forEach((el) => {
          const rect = el.getBoundingClientRect();
          const visible = rect.top < window.innerHeight && rect.bottom > 0;
          if (visible) slideshows.push(el);
        });
      });
  
      if (!slideshows.length) return false;
  
      // For each visible slideshow, check active slide
      for (const slideshow of slideshows) {
        let activeSlide = null;
        
        if (slideshow.tagName === 'SAS-SLIDESHOW-COMPONENT') {
          activeSlide = getActiveSlideSas(slideshow);
        } else if (slideshow.tagName === 'M-SLIDESHOW') {
          activeSlide = getActiveSlideM(slideshow);
        }
  
        if (!activeSlide) continue;
  
        // Check images in active slide
        const images = activeSlide.querySelectorAll('img');
        for (const img of images) {
          if (imageHasKeyword(img)) {
            return true; // Found keyword → hide
          }
        }
      }
  
      return false;
    }
  
    function update() {
      if (scrollTimer) return;
      
      scrollTimer = setTimeout(() => {
        try {
          if (!document.body || !isInitialized) return;
  
          const targets = getTargets();
          if (!targets.length) return;
  
          // By default, hide all
          targets.forEach((widget) => {
            hideWidget(widget);
          });
  
          // Only show if validation allows
          const shouldShow = !shouldHide();
          
          if (shouldShow) {
            targets.forEach((widget) => {
              showWidget(widget);
            });
          }
        } catch (e) {
          // Ignore
        } finally {
          scrollTimer = null;
        }
      }, 150);
    }
  
    function setupSlideChangeListeners() {
      // Listener for sas-slideshow-component (slideChanged event)
      document.querySelectorAll('sas-slideshow-component').forEach((slideshow) => {
        if (slideshow.dataset.chatListenerAdded) return;
        slideshow.addEventListener('slideChanged', () => {
          update();
        });
        slideshow.dataset.chatListenerAdded = 'true';
      });
  
      // Listener for m-slideshow (Swiper)
      document.querySelectorAll('m-slideshow').forEach((slideshow) => {
        if (slideshow.dataset.chatListenerAdded) return;
        
        const container = slideshow.querySelector('.swiper-container');
        if (container?.swiper) {
          container.swiper.on('slideChange', () => {
            update();
          });
        }
        
        // Observer for class changes (when Swiper changes active slide)
        const observer = new MutationObserver(() => {
          update();
        });
        const wrapper = slideshow.querySelector('.swiper-wrapper');
        if (wrapper) {
          observer.observe(wrapper, {
            attributes: true,
            attributeFilter: ['class'],
            subtree: true
          });
        }
        
        slideshow.dataset.chatListenerAdded = 'true';
      });
    }
  
    function init() {
      if (isInitialized) return;
      
      config = window.SAS_CHAT_CONFIG;
      if (!config?.enabled) return;
  
      keywords = parseKeywords(config.bannerKeyword || '');
      customSelectors = parseSelectors(config.customSelectors || '');
      isInitialized = true;
  
      // Hide immediately on initialization
      const targets = getTargets();
      targets.forEach((widget) => {
        hideWidget(widget);
      });
  
      // Setup slide change listeners
      setupSlideChangeListeners();
  
      // Observer for newly added slideshows
      const observer = new MutationObserver(() => {
        setupSlideChangeListeners();
      });
      if (document.body) {
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
  
      // Initial
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          setupSlideChangeListeners();
          setTimeout(update, 200);
        });
      } else {
        setupSlideChangeListeners();
        setTimeout(update, 200);
      }
  
      // Scroll and resize
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      setTimeout(init, 100);
    }
  })();
  